export const figure67 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '900px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#70ad47', '#a9d18e', '#e2f0d9', '#385723'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: ["Monde", "", "Australie et Nouvelle-Zélande", "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)", "Amérique latine et Caraïbes", "Amérique du Nord", "Europe", "Afrique subsaharienne", "Afrique du Nord", "Asie de l’Ouest", "Asie du Sud-Est", "Asie de l’Est", "Asie du Sud", "Asie centrale"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        max: 100,
        min: 0,
        tickInterval: 10,
          gridLineWidth: 2,
        title: {
          text: false,
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2000',
        data: [31.9, null, 17.8, 77.1, 50.8, 35.1, 45.3, 30.8, 3.9, 5.8, 50.7, 19.8, 14.9, 3.0],
      },
      {
        name: '2010',
        data: [31.5, null, 17.5, 77.0, 48.1, 35.4, 45.8, 29.3, 3.7, 6.1, 49.7, 21.8, 15.3, 3.1]
      },
	{
	  name: '2015',
	  data: [31.3, null, 18.0, 76.7, 47.4, 35.5, 45.9, 28.5, 3.6, 6.2, 48.2, 22.7, 15.5, 3.2]
	},
	{
	name: '2020',
	data: [31.1, null, 18.1, 76.5, 46.7, 35.5, 46.0, 27.6, 3.5, 6.3, 47.1, 23.5, 15.7, 3.3]
	}
    ]
}
